export default __webpack_public_path__ + "static/media/(79).f47dd339.jpg";